/**
 * @module experience/landing
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */

import { Routes } from '@angular/router';
import { AccountLandingComponent } from '@experience/landing/common/components/account-landing/account-landing.component';
import { LineSelectorComponent } from '@experience/landing/common/components/line-selector/line-selector.component';
import { LoadAuthenticationGuardService } from '@support/shared/widgets/services/load-authentication-guard.service';

export const LANDING_COMMON_ROUTES: Routes = [
  {
    path: 'account-landing',
    component: AccountLandingComponent,
    canActivate: [LoadAuthenticationGuardService],
    data: { pdlPageComponentId: 'AccountLandingComponent' },
  },
  {
    path: 'line-selector',
    component: LineSelectorComponent,
    canActivate: [LoadAuthenticationGuardService],
    data: { pdlPageComponentId: 'LineSelectorComponent' },
  },
];
